import {ValueObject} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../Errors/InvalidParamsSharedError.js'

export class BooleanSharedValueObject extends ValueObject {
  #value

  static validate({value}) {
    if (typeof value !== 'boolean') {
      throw InvalidParamsSharedError.create(`[NumberSharedValueObject.validate] value(${value}) should be a boolean`)
    }
  }

  static normalize({value}) {
    return Boolean(value)
  }

  static isEmpty({value}) {
    return value === undefined || value === null
  }

  static create({value}) {
    const normalizedBoolean = BooleanSharedValueObject.normalize({value})
    const isEmpty = BooleanSharedValueObject.isEmpty({value})
    !isEmpty && BooleanSharedValueObject.validate({value: normalizedBoolean})
    const currentValue = isEmpty ? value : normalizedBoolean
    return new BooleanSharedValueObject({value: currentValue})
  }

  static createWithoutEmptyValue({value}) {
    const normalizedBoolean = BooleanSharedValueObject.normalize({value})
    BooleanSharedValueObject.validate({value: normalizedBoolean})
    return new BooleanSharedValueObject({value: normalizedBoolean})
  }

  constructor({value}) {
    super()
    this.#value = value
  }

  get value() {
    return this.#value
  }

  toJSON() {
    return {value: this.#value}
  }
}
